/**
 * The one way a gated action asks the seeker to sign in.
 *
 * There used to be three: window.dispatchEvent('request-auth'), an emitted
 * 'require-login', and direct showLogin = true inside ReaderPage. None carried
 * a reason, so the modal could not say what the seeker was reaching for, and
 * only two of them set the Register tab. Everything goes through here now.
 *
 *   requestAuth('collection', { action: 'favorite-image', args: { url } })
 */
import { store } from '@/store'
import { isResumable } from '@/utils/auth-intents'
import { track } from '@/utils/analytics'

export function requestAuth(theme, resume = null, { forName = '', reason = '' } = {}) {
  store.authIntent = {
    theme: theme || '',
    // Drop anything we cannot actually replay rather than storing a promise we
    // will not keep. isResumable is the single source of truth for that.
    resume: isResumable(resume) ? resume : null,
    // The send door names the person the reading is for (R3.8).
    ...(forName ? { forName } : {}),
    // A members-only link's reason (navigation API §6).
    ...(reason ? { reason } : {}),
  }
  // A gated action means no account is in hand: Register. A members-only
  // link is for someone who has one: Login.
  store.login_current_tab = theme === 'reason' ? 'login' : 'register'
  track('login_required_shown', { theme: theme || '', action: resume && resume.action })
  window.dispatchEvent(new CustomEvent('request-auth'))
}

/** Read and consume the pending intent, so a resume can only fire once. */
export function takeAuthIntent() {
  const intent = store.authIntent
  store.authIntent = null
  return intent || null
}

export function clearAuthIntent() {
  store.authIntent = null
}
